module.exports = "<h3>\n  {{\"page-not-found\"|translate}}\n</h3>\n"